(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["upsell-product-v2"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('zoeva-upsell-product-v2-block')) {
    customElements.define('zoeva-upsell-product-v2-block', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.button = this.querySelector('[data-add]');
        this.status = this.querySelector('[data-status]');
        this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
        this.button.addEventListener('click', () => this.addSelection());
      }

      async readCart() {
        const response = await fetch(this.dataset.cartUrl, { cache: 'no-store' });
        if (!response.ok) throw new Error('Cart unavailable');
        return response.json();
      }

      itemQuantity(cart, item) {
        return cart.items.reduce((total, line) => {
          const plan = Number(line.selling_plan_allocation?.selling_plan?.id || 0);
          return Number(line.variant_id) === item.id && plan === (item.selling_plan || 0)
            ? total + line.quantity : total;
        }, 0);
      }

      async addSelection() {
        if (this.pending) return;
        this.status.hidden = true;
        const form = document.getElementById(this.dataset.formId);
        if (!form || !form.reportValidity() || typeof window.addItemsToIACartDrawer !== 'function' || typeof window.openIACartDrawer !== 'function') {
          this.showStatus(this.dataset.error);
          return;
        }
        const values = new FormData(form);
        const variantId = Number(values.get('id') || form.elements.namedItem('id')?.value);
        const variant = this.variants.find(item => item.id === variantId);
        const quantity = Number(values.get('quantity') || 1);
        const hasProperties = Array.from(values).some(([key, value]) => key.startsWith('properties[') && value !== '');
        if (!variant?.available || !Number.isInteger(quantity) || quantity < 1 || hasProperties) {
          this.showStatus(this.dataset.error);
          return;
        }
        const mainItem = { id: variantId, quantity };
        const sellingPlan = Number(values.get('selling_plan'));
        if (sellingPlan) mainItem.selling_plan = sellingPlan;
        const items = [mainItem];
        if (this.querySelector('[data-addon]').checked) {
          const addonId = Number(this.dataset.addonId);
          if (addonId === variantId && !sellingPlan) mainItem.quantity += 1;
          else items.push({ id: addonId, quantity: 1 });
        }
        this.pending = true;
        this.button.disabled = true;
        this.setAttribute('aria-busy', 'true');
        try {
          const before = await this.readCart();
          const expected = items.map(item => this.itemQuantity(before, item) + item.quantity);
          await window.addItemsToIACartDrawer(items);
          let confirmed = false;
          for (let attempt = 0; attempt < 20; attempt += 1) {
            const cart = await this.readCart();
            if (items.every((item, index) => this.itemQuantity(cart, item) >= expected[index])) {
              confirmed = true;
              break;
            }
            await new Promise(resolve => setTimeout(resolve, 500));
          }
          if (!confirmed) throw new Error('Addition not confirmed');
          window.openIACartDrawer();
          this.showStatus(this.dataset.success);
        } catch (error) {
          this.showStatus(this.dataset.error);
        } finally {
          this.pending = false;
          this.button.disabled = false;
          this.removeAttribute('aria-busy');
        }
      }

      showStatus(message) {
        this.status.textContent = message;
        this.status.hidden = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
